import 'idempotent-babel-polyfill';
import alt from '../../alt';
import MyAddressesActions from './MyAddressesActions';
import AddressModel from '../../Addresses/AddressModel';

class MyAddressesStore {
	constructor() {
		this.state = {
			homeAddress: null,
			shippingAddress: null,
			additionalAddresses: [],
			showEditHomeAddress: false,
			showShippingAddress: false,
			showEditShippingAddress: false,
			showAdditionalAddresses: false,
			showCreateAdditionalAddress: false,
			showEditAdditionalAddress: [],
			shippingSameAsHome: true
		};

		this.bindListeners({
			addressesChanged: MyAddressesActions.GET_ADDRESSES_SUCCESS,
			toggleEditHomeAddress: MyAddressesActions.TOGGLE_EDIT_HOME_ADDRESS,
			toggleEditShippingAddress: MyAddressesActions.TOGGLE_EDIT_SHIPPING_ADDRESS,
			toggleCreateAdditionalAddress: MyAddressesActions.TOGGLE_CREATE_ADDITIONAL_ADDRESS,
			toggleEditAdditionalAddress: MyAddressesActions.TOGGLE_EDIT_ADDITIONAL_ADDRESS,
			toggleShippingSameAsHome: MyAddressesActions.TOGGLE_SHIPPING_SAME_AS_HOME
    });
	}

	addressesChanged(addresses) {
		var homeAddress = new AddressModel(addresses.home);
		var shippingAddress = new AddressModel(addresses.shipping);
		var additionalAddresses = [];
        var bookShippingAddress = [];
        if (addresses.shipping !== null) {
			bookShippingAddress = new AddressModel(addresses.shipping);
		} else {
			bookShippingAddress = new AddressModel(addresses.home);
        }
        addresses.additional.map((address) => additionalAddresses.push(new AddressModel(address)));
        this.setState({
            homeAddress: homeAddress,
            shippingAddress: shippingAddress,
            additionalAddresses: additionalAddresses,
            showShippingAddress: addresses.home != null,
            showAdditionalAddresses: addresses.home != null,
            bookShippingAddress: bookShippingAddress
    });
	}

	toggleEditHomeAddress(isOpen) {
		this.setState({
			showEditHomeAddress: isOpen
		});
	}

	toggleEditShippingAddress(isOpen) {
		this.setState({
			showEditShippingAddress: isOpen
		});
	}

	toggleCreateAdditionalAddress(isOpen) {
		this.setState({
			showCreateAdditionalAddress: isOpen
		});
	}

	toggleEditAdditionalAddress(diff) {
		this.setState({
			showEditAdditionalAddress: Object.assign(this.state.showEditAdditionalAddress, diff)
		});
	}

	toggleShippingSameAsHome(isSame) {
		this.setState({
			shippingSameAsHome: isSame
		});
	}

}

export default alt.createStore(MyAddressesStore, 'MyAddressesStore');



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/MyAddresses/MyAddressesStore.js